import { CreditNoteResponseDto } from "../shared/dtos/creditNote/CreditNoteResponseDto";
import { CreditNoteSummaryDto } from "../shared/dtos/creditNote/CreditNoteSummaryDto";

export class CreditNoteMapper {
  public static mapCreditNoteToSummary(
    note: CreditNoteResponseDto,
  ): CreditNoteSummaryDto {
    return {
      id: note.id,
      noteNumber: note.noteNumber,
      issueDate: note.issueDate,
      transactionStatus: note.transactionStatus,
      status: note.status,
      reason: note.reason,
      customerName: note.customerName,
      currencyCode: note.currencyCode,
      exchangeRate: note.exchangeRate,
      subtotal: note.subtotal,
      totalTaxableAmount: note.totalTaxableAmount,
      totalTax: note.totalTax,
      total: note.total,
      amountUsed: note.amountUsed,
    };
  }
}
